import { getVenue } from '../../../../../ui-kitchen/src/api/api';
import { venueTransform } from '../../../../../ui-kitchen/src/api/resyApiTransformer';
import { ISO_DATE_FORMAT } from '../../../../../ui-kitchen/src/constants/resyCore';
import { getURLSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';
import { getLocationUrl } from '../../../../../ui-kitchen/src/utils/locationUtils';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

/* eslint-disable import/prefer-default-export */
const loadVenueInventory = ({
  getVenueInventoryThunk, isSm, selectedDate, selectedQuantity, venueId,
}) => {
  const params = {
    venue_id: venueId,
    num_seats: selectedQuantity,
    start_date: moment(selectedDate).startOf('month').format('YYYY-MM-DD'),
    end_date: moment().add(1, 'year').format(ISO_DATE_FORMAT),
  };
  if (isSm) {
    params.end_date = moment(selectedDate).add(1, 'months').endOf('month').format(ISO_DATE_FORMAT);
  } else {
    params.end_date = moment(selectedDate).endOf('month').format(ISO_DATE_FORMAT);
  }
  return getVenueInventoryThunk({ params });
};

const loadReservations = ({
  getVenueReservationsThunk, maxQuantity, selectedDate, selectedQuantity, setReservations, venueId,
}) => {
  if (selectedQuantity > maxQuantity) {
    setReservations([]);
  } else {
    setReservations(null);
    const searchParams = getURLSearchParams();
    const resyToken = searchParams.get('resyToken') || undefined;
    const params = {
      venue_id: venueId,
      day: moment(selectedDate).format(ISO_DATE_FORMAT),
      party_size: selectedQuantity,
      resy_token: resyToken,
    };
    getVenueReservationsThunk({ params });
  }
};

const loadVenue = ({ locationId, venueSlug, venueId }) => {
  const requestParams = {};
  if (venueId) {
    requestParams.id = venueId;
  } else if (locationId && venueSlug) {
    requestParams.url_slug = venueSlug;
    requestParams.location = locationId;
  } else {
    Logger.error(`EventDetailsController loadVenue bad path: url: ${getLocationUrl()}`, venueId);
  }
  return getVenue(requestParams).then((data) => venueTransform(data));
};

const loadResyConfig = ({
  getResyConfigVenueThunk,
  setSelectedCoreSeatsMinMax,
  venueId,
}) => getResyConfigVenueThunk(venueId)
  .then((config) => {
    if (!config) {
      return;
    }
    let isLargePartyConfigured = false;
    if ('large_party' in config && 'message' in config.large_party && !!config.large_party.message) {
      isLargePartyConfigured = true;
    }
    const params = {
      isLargePartyConfigured,
      max: config.venue.maxPartySize,
      min: config.venue.minPartySize,
    };
    setSelectedCoreSeatsMinMax(params);
  })
  .catch(() => Logger.error('[CATCH] EventDetailsController: getResyConfigVenueThunk'));

export {
  loadReservations,
  loadResyConfig,
  loadVenue,
  loadVenueInventory,
};
